import { render, staticRenderFns } from "./RemunerationsDocsTable.vue?vue&type=template&id=3e0e6910&scoped=true"
import script from "./RemunerationsDocsTable.vue?vue&type=script&lang=js"
export * from "./RemunerationsDocsTable.vue?vue&type=script&lang=js"
import style0 from "./RemunerationsDocsTable.vue?vue&type=style&index=0&id=3e0e6910&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0e6910",
  null
  
)

export default component.exports